import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { CurrentOrganizationDto, ResponseDto } from "@mimber/schema"
import { organizationKeys } from "../organization.utils"
import type { UseCurrentOrganizationReturn } from "./useCurrentOrganization.types"

/**
 * Hook to fetch the current organization context with user's relationship and permissions
 * Can only be used in mimber-organization app
 * Uses x-organization-id header to determine which organization to fetch
 */
export const useCurrentOrganization = (
  options?: UseQueryOptions<ResponseDto<CurrentOrganizationDto>, Error>
): UseCurrentOrganizationReturn => {
  guardAppUsage("mimber-organization", "useCurrentOrganization")

  const { server } = useServerContext()

  return useQuery({
    queryKey: organizationKeys.getCurrentOrganization(),
    queryFn: async () => {
      const response =
        await server.get<ResponseDto<CurrentOrganizationDto>>("/organization")
      return response.data
    },
    ...options,
  })
}
